const googleClientId = 'gme-mercadolibre';
const googleMapChannel = 'VIP_REAL_ESTATE';

export { googleClientId, googleMapChannel };
